module.exports = __webpack_public_path__ + "static/app-screen-3-62c5ff4566b37ba459bce1b246be3819.png";